<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"
        stroke-dasharray="3 4" />
</svg>
    
